import {init as initState} from 'core/LifeCycle';
import {rewriteState} from 'setup/rewriteState';

export function init(): void {
  const state = initState();
  rewriteState(state);
}
